
// React Imports
import * as React from "react";
import {useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import {
    DataGrid,
} from '@mui/x-data-grid';
import Box from "@mui/material/Box";

import {
    Avatar,
    Tooltip
} from "@mui/material";

// App Imports
import {getContractStatsReleaseMarket} from "../../Contract/ContractClient";
import CustomFooter from "../../CommonComponents/GridCustomFooter";
import {changeContractStats} from "./contractStatsSlice";
import {changeContractStatsControls} from "./contractStatsControlsSlice";
import {StatsMenu} from "./StatsMenu";

// main function
export default function ReleaseMarketContractStatsGrid() {

    // ****************** BEGIN STATES ****************************

    const [releaseMarketContractStats, setReleaseMarketContractStats] = useState([]);
    const [gridVisible, setGridVisible] = React.useState(true);


    // ****************** END STATES ****************************


    // *********************** BEGIN STORE ********************************


    const hideActions = localStorage.getItem('hideActions') === "true";
    const dispatchData = useDispatch();

    // ********************** END STORE ********************************


    // ****************** BEGIN FETCH ****************************

    const fetchReleaseMarketContractStats = () =>
        getContractStatsReleaseMarket()

            .then(data => {
                console.log(data);
                setReleaseMarketContractStats(data);
            })
    useEffect(() => {
        fetchReleaseMarketContractStats();
    }, []);

    // ****************** END FETCH ****************************


    const renderReleaseMarketContractStats = releaseMarketContractStats => {
        if (releaseMarketContractStats.length <= 0) {
            return "No Data";
        }}


    // ****************** BEGIN CRUD ***********************************



    // ****************** END CRUD ***********************************



    // ****************** BEGIN DRILLDOWN ****************************

    // ****************** END DRILLDOWN ****************************

    const handleClickedRow = (releaseMarketContractStats) => {

        console.log('Stats data from clicked row');
        console.log(releaseMarketContractStats);
        dispatchData(changeContractStats({marketGroupId: releaseMarketContractStats.marketGroupId, marketGroupName: releaseMarketContractStats.marketGroupName,
         releaseMarketId: releaseMarketContractStats.releaseMarketId, releaseMarketName: releaseMarketContractStats.releaseMarketName,
            seriesId: null, seriesName: null, seasonId: null, seasonName: null, productId: null, episodeName: null, photoStartDate: null}));
        dispatchData(changeContractStatsControls({gridDisplay: "SeriesFullScreen"}));
    };





    // ****************** BEGIN COLUMNS ****************************

    const columns = releaseMarketContractStats => [

        {    field: 'more',
            headerName: '',
            description: '',
            sortable: true,
            width: 60,
            hide: false,
            renderCell: (params) => (
                <div onClick={(event) => event.stopPropagation()}>
                    <StatsMenu row={params.row}  />
                </div>
            )
        },
        {    field: 'id',
            headerName: 'ID',
            description: '',
            sortable: true,
            width: 60,
            hide: true,
        },
        {
            field: 'm4mktGroupName',
            headerName: 'Market Group',
            description: '',
            sortable: true,
            editable: true,
            hide: false,
            // editable: true,
            width: 220,
        },
        {
            field: 'm4mktGroupId',
            headerName: 'Market Group ID',
            description: '',
            sortable: false,
            editable: false,
            width: 100,
            hide: true,
        },
        {
            field: 'releaseMarketName',
            headerName: 'Release Market',
            description: '',
            sortable: true,
            editable: true,
            hide: false,
            // editable: true,
            width: 240,
        },
        {
            field: 'releaseMarketId',
            headerName: 'Release Market ID',
            description: '',
            sortable: false,
            editable: false,
            width: 100,
            hide: true,
        },
        {
            field: 'standAloneCount',
            headerName: 'Stand Alone',
            width: 100,
            headerAlign: 'center',
            renderCell: (releaseMarketContractStats) => {
                const count = releaseMarketContractStats.row.standAloneCount;

                if (count === 0 || count === null || count === undefined) return "";

                // Calculate width based on digit count
                const digitCount = count.toString().length;
                const width = 20 + (digitCount - 1) * 10; // Start at 20, add 10px per extra digit

                return (
                    <Box sx={{
                        width: "100%",
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <Tooltip title="Count of stand alone products with contracts.">
                            <Avatar variant="rounded" sx={{
                                height: 20,
                                width,
                                fontSize: 16,
                                backgroundColor: "rgb(30,144,255)",
                                color: "rgb(255, 255, 255)"
                            }}>
                                {count}
                            </Avatar>
                        </Tooltip>
                    </Box>
                );
            }
        },
        {
            field: 'seriesCount',
            headerName: 'Series',
            headerAlign: 'center',
            width: 100,
            renderCell: (releaseMarketContractStats) => {
                const count = releaseMarketContractStats.row.seriesCount;

                if (count === 0 || count === null || count === undefined) return "";

                // Calculate width based on digit count
                const digitCount = count.toString().length;
                const width = 20 + (digitCount - 1) * 10; // Start at 20, add 10px per extra digit

                return (
                    <Box sx={{
                        width: "100%",
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <Tooltip title="Count of series with contracts.">
                            <Avatar variant="rounded" sx={{
                                height: 20,
                                width,
                                fontSize: 16,
                                backgroundColor: "rgb(30,144,255)",
                                color: "rgb(255, 255, 255)"
                            }}>
                                {count}
                            </Avatar>
                        </Tooltip>
                    </Box>
                );
            }
        },
        {
            field: 'seasonCount',
            headerName: 'Seasons',
            headerAlign: 'center',
            width: 100,
            renderCell: (releaseMarketContractStats) => {
                const count = releaseMarketContractStats.row.seasonCount;

                if (count === 0 || count === null || count === undefined) return "";

                // Calculate width based on digit count
                const digitCount = count.toString().length;
                const width = 20 + (digitCount - 1) * 10; // Start at 20, add 10px per extra digit

                return (
                    <Box sx={{
                        width: "100%",
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <Tooltip title="Count of seasons with contracts.">
                            <Avatar variant="rounded" sx={{
                                height: 20,
                                width,
                                fontSize: 16,
                                backgroundColor: "rgb(30,144,255)",
                                color: "rgb(255, 255, 255)"
                            }}>
                                {count}
                            </Avatar>
                        </Tooltip>
                    </Box>
                );
            }
        },
        {
            field: 'episodeCount',
            headerName: 'Episodes',
            headerAlign: 'center',
            width: 100,
            renderCell: (releaseMarketContractStats) => {
                const count = releaseMarketContractStats.row.episodeCount;

                if (count === 0 || count === null || count === undefined) return "";

                // Calculate width based on digit count
                const digitCount = count.toString().length;
                const width = 20 + (digitCount - 1) * 10; // Start at 20, add 10px per extra digit

                return (
                    <Box sx={{
                        width: "100%",
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <Tooltip title="Count of episodes with contracts.">
                            <Avatar variant="rounded" sx={{
                                height: 20,
                                width,
                                fontSize: 16,
                                backgroundColor: "rgb(30,144,255)",
                                color: "rgb(255, 255, 255)"
                            }}>
                                {count}
                            </Avatar>
                        </Tooltip>
                    </Box>
                );
            }
        },
        {
            field: 'products',
            headerName: 'Products',
            headerAlign: 'center',
            width: 100,
            renderCell: (releaseMarketContractStats) => {
                const count = releaseMarketContractStats.row.productCount;

                if (count === 0 || count === null || count === undefined) return "";

                // Calculate width based on digit count
                const digitCount = count.toString().length;
                const width = 20 + (digitCount - 1) * 10; // Start at 20, add 10px per extra digit

                return (
                    <Box sx={{
                        width: "100%",
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <Tooltip title="Count of episodes with contracts.">
                            <Avatar variant="rounded" sx={{
                                height: 20,
                                width,
                                fontSize: 16,
                                backgroundColor: "rgb(30,144,255)",
                                color: "rgb(255, 255, 255)"
                            }}>
                                {count}
                            </Avatar>
                        </Tooltip>
                    </Box>
                );
            }
        },

        {
            field: 'guildCount',
            headerName: 'Guilds',
            width: 100,
            headerAlign: 'center',
            renderCell: (releaseMarketContractStats) => {
                const count = releaseMarketContractStats.row.guildCount;

                if (count === 0 || count === null || count === undefined) return "";

                // Calculate width based on digit count
                const digitCount = count.toString().length;
                const width = 20 + (digitCount - 1) * 10; // Start at 20, add 10px per extra digit

                return (
                    <Box sx={{
                        width: "100%",
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <Tooltip title="Count of guild contracts.">
                            <Avatar variant="rounded" sx={{
                                height: 20,
                                width,
                                fontSize: 16,
                                backgroundColor: "rgb(30,144,255)",
                                color: "rgb(255, 255, 255)"
                            }}>
                                {count}
                            </Avatar>
                        </Tooltip>
                    </Box>
                );
            }
        },

        {
            field: 'guilds',
            headerName: 'Guilds',
            description: '',
            sortable: true,
            editable: false,
            hide: false,
            // editable: true,
            width: 380,
        },
        {
            field: 'approvedCount',
            headerName: 'Approved',
            width: 100,
            headerAlign: 'center',
            renderCell: (releaseMarketContractStats) => {
                const count = releaseMarketContractStats.row.approvedCount;

                if (count === 0 || count === null || count === undefined) return "";

                // Calculate width based on digit count
                const digitCount = count.toString().length;
                const width = 20 + (digitCount - 1) * 10; // Start at 20, add 10px per extra digit

                return (
                    <Box sx={{
                        width: "100%",
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <Tooltip title="Count of approved contracts.">
                            <Avatar variant="rounded" sx={{
                                height: 20,
                                width,
                                fontSize: 16,
                                backgroundColor: "rgb(30,144,255)",
                                color: "rgb(255, 255, 255)"
                            }}>
                                {count}
                            </Avatar>
                        </Tooltip>
                    </Box>
                );
            }
        },
        {
            field: 'unapprovedCount',
            headerName: 'Unapproved',
            width: 100,
            headerAlign: 'center',
            renderCell: (releaseMarketContractStats) => {
                const count = releaseMarketContractStats.row.unapprovedCount;

                if (count === 0 || count === null || count === undefined) return "";

                // Calculate width based on digit count
                const digitCount = count.toString().length;
                const width = 20 + (digitCount - 1) * 10; // Start at 20, add 10px per extra digit

                return (
                    <Box sx={{
                        width: "100%",
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <Tooltip title="Count of unapproved contracts.">
                            <Avatar variant="rounded" sx={{
                                height: 20,
                                width,
                                fontSize: 16,
                                // backgroundColor: "rgb(30,144,255)",
                                backgroundColor: "warning.main",
                                color: "rgb(255, 255, 255)"
                            }}>
                                {count}
                            </Avatar>
                        </Tooltip>
                    </Box>
                );
            }
        },

    ];

    // ****************** END COLUMNS ****************************


    // ****************** BEGIN TOOLBAR ****************************



    // ****************** END TOOLBAR ****************************

    // ****************** BEGIN RETURN ****************************

    return (
        <div style={{ height:800 , width: '100%' }}>
            <Box sx={{height: 70, pt: 1, pl: 3}}>
                <h3>Release Market Contract Statistics</h3>
            </Box>
            {gridVisible && <DataGrid
                experimentalFeatures={{ newEditingApi: true }}
                initialState={{
                }}
                style={{cursor: 'pointer'}}
                aria-label={"ReleaseMarketContractStats"}
                rows={releaseMarketContractStats}
                disableDensitySelector={true}
                disableColumnSelector={true}
                columns={columns(fetchReleaseMarketContractStats)}
                onRowClick = {(releaseMarketContractStats)=>handleClickedRow(releaseMarketContractStats.row)}
                density={"compact"}
                pageSize={20}
                rowsPerPageOptions={[20]}
                rowKey={releaseMarketContractStat => releaseMarketContractStat.id}
                components={{
                    // Toolbar: CustomToolbar,
                    Footer: CustomFooter,
                }}
            />}
        </div>
    );

    // ****************** END RETURN ****************************

}

